<template>
  <div>
    <b-row>
      <b-col>
        <card-list-info header="Shipment Detail" :items="detailInfo"></card-list-info>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <card-list-info header="Company Information" :items="companyInfo"></card-list-info>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <card-list-info header="Origin" :items="originInfo">
          <template slot="map" slot-scope={data}>
            <b-btn v-b-toggle.map size="sm" variant="primary" @click="showHideMap">
              {{ !showMap ? 'Show Map' : 'Hide Map' }}
            </b-btn>
            <b-collapse id="map" class="mt-2">
              <base-map
                ref="map"
                :marker="data.value.marker"
                :center="data.value.center"
                :popup="data.value.name"
                :coordinates="data.value.coordinates"
                :radius="data.value.radius"
                :isCircle="data.value.isCircle"
                :latlngs="data.value.latlngs">
              </base-map>
            </b-collapse>
          </template>
        </card-list-info>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!-- <card-list-info header="Route" :items="routeInfo">
          <template slot="maps" slot-scope={data}>
            <b-col id="maps" class="mt-2" style="height: 600px">
              <Mapbox
                ref="maptest"
                map-container="maps"
                :zoom="zoom"
                :all-data="data.value"
                :center="data.value.center"
                :latlngs="data.value.latlngs">
              </Mapbox>
            </b-col>
          </template>
        </card-list-info> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="loader1Confirm">
        <card-list-info header="Loader 1 Confirm" :items="loader1Info">
          <template slot="signature" slot-scope={data} v-show="!isNull(loader1Info.signature)">Signature :
            <img class="confirm-signature" :src="createSignature(data.value)" alt="signature">
          </template>
        </card-list-info>
      </b-col>
      <b-col v-if="loader2Confirm">
        <card-list-info header="Loader 2 Confirm" :items="loader2Info">
          <template slot="signature" slot-scope={data} v-show="!isNull(loader2Info.signature)">Signature :
            <img class="confirm-signature" :src="createSignature(data.value)" alt="signature">
          </template>
        </card-list-info>
      </b-col>
      <b-col v-if="driver1Confirm">
        <card-list-info header="Driver 1 Confirm" :items="driver1Info">
          <template slot="signature" slot-scope={data}>Signature :
            <img class="confirm-signature" :src="createSignature(data.value)" alt="signature">
          </template>
        </card-list-info>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="driver2Confirm">
        <card-list-info header="Driver 2 Confirm" :items="driver2Info">
          <template slot="signature" slot-scope={data}>Signature :
            <img class="confirm-signature" :src="createSignature(data.value)" alt="signature">
          </template>
        </card-list-info>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import isNull from 'lodash/isNull';
import values from 'lodash/values';
import get from 'lodash/get';

import L from 'leaflet';

import dateMixin from '@/mixins/date';
import CardListInfo from '@/components/CardListInfo';
import BaseMap from '@/components/BaseMap';
import Mapbox from '@/components/Mapbox';

const { methods: dateMethods } = dateMixin;

const createConfirmationInfo = (data) => {
  if (!data) { return []; }
  const infoList = [
    { key: 'name', label: 'Name', value: data.name },
    { key: 'confirmed_at', label: 'Confirmed at', value: dateMethods.formatDateTime(data.created_at) },
    // { key: 'signature', label: 'Signature', value: data.signature },
  ];
  if (!isNull(data.signature)) {
    infoList.push({ key: 'signature', label: 'Signature', value: data.signature });
  }

  return infoList;
};

export default {
  mixins: [dateMixin],
  components: {
    CardListInfo,
    BaseMap,
    Mapbox,
  },
  data() {
    return {
      zoom: 12,
      selectedCompany: null,
      showMap: false,
      showMapbox: false,
      loader1Confirm: false,
      loader2Confirm: false,
      driver1Confirm: false,
      driver2Confirm: false,
      mapObject: {},
      setInvalidateSize: false,
    };
  },
  created() {
    this.$store.commit('companies/CLEAR_QUERY');
    this.$store.dispatch('companies/LOAD_DETAIL_DATA');
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => { this.mapObject = this.$refs.map.$refs.map.mapObject; }, 5e2);
    });
  },
  computed: {
    companies() {
      return this.$store.getters['companies/companies'];
    },
    number() {
      return this.detailedInfo.number;
    },
    detailedInfo() {
      return this.$store.getters['shipment_md/shipments/get_detail_data'];
    },
    detailInfo() {
      const info = this.detailedInfo;
      const vehicle = info.vehicle || {};
      const driver = info.driver || {};
      const infoList = [
        { key: 'number', label: 'Number', value: info.number },
        { key: 'truck', label: 'Truck', value: vehicle.reg_no },
        { key: 'driver', label: 'Driver', value: driver.name },
        {
          key: 'created_at',
          label: 'Created at',
          value: this.formatDateDistance(info.created_at),
          title: this.formatDateTime(info.created_at),
        },
        {
          key: 'last_update',
          label: 'Last Update',
          value: this.formatDateDistance(info.updated_at),
          title: this.formatDateTime(info.updated_at),
        },

      ];

      return infoList;
    },
    companyInfo() {
      const info = this.detailedInfo;
      const company = info.company || {};
      const infoList = [
        { key: 'company', label: 'Name', value: company.name },
      ];

      return infoList;
    },
    originInfo() {
      const origin = get(this.detailedInfo, 'origin', {});
      const metadata = get(origin, 'metadata', {});
      const geometry = get(origin, 'geometry', { coordinates: [[0, 0]] });
      const code = get(origin, 'code', '');
      const name = get(origin, 'name', '');
      const longitude = get(origin, 'longitude', '');
      const latitude = get(origin, 'code', '');
      const isTrue = true;
      let coordinates = [0, 0];
      let center = [0, 0];
      let marker = { lat: 0, lng: 0 };
      const radius = !isNull(metadata) ? metadata.radius : 200;
      const isCircle = !isNull(metadata) && geometry.type === 'Point' ? isTrue : !isTrue;
      const latlngs = geometry.coordinates;

      if (isCircle) {
        if (isNull(longitude) && isNull(latitude)) {
          center = geometry.coordinates;
          coordinates = { geometry: { coordinates } };
          marker = { lat: geometry.coordinates[0], lng: geometry.coordinates[1] };
        } else {
          center = [latitude, longitude];
          coordinates = [latitude, longitude];
          marker = { lat: latitude, lng: longitude };
        }
      } else {
        const polygon = L.polygon(geometry.coordinates);
        const getCenter = polygon.getBounds().getCenter();
        center = values(getCenter);
        marker = getCenter;
      }

      const mapValue = {
        marker, center, name, coordinates, radius, latlngs, isCircle,
      };

      const infoList = [
        { key: 'code', label: 'Code', value: code },
        { key: 'name', label: 'Name', value: name },
        { key: 'map', label: 'Map', value: mapValue },
      ];

      return infoList;
    },
    routeInfo() {
      /* if (isEmpty(this.detailedInfo)) {
        return {};
      } */
      // eslint-disable-next-line no-debugger
      // debugger;
      const { origin = {} } = this.detailedInfo;
      const { metadata = {}, geometry = { coordinates: [[0, 0]] } } = origin;
      const {
        code, name, longitude, latitude,
      } = origin;
      const isTrue = true;
      let coordinates = [0, 0];
      let center = [0, 0];
      let marker = { lat: 0, lng: 0 };
      // const radius = !isNull(metadata) ? metadata.radius : 200;
      const isCircle = !isNull(metadata) && geometry.type === 'Point' ? isTrue : !isTrue;
      const latlngs = geometry.coordinates;

      if (isCircle) {
        if (isNull(longitude) && isNull(latitude)) {
          center = geometry.coordinates;
          coordinates = { geometry: { coordinates } };
          marker = { lat: geometry.coordinates[0], lng: geometry.coordinates[1] };
        } else {
          center = [latitude, longitude];
          coordinates = [latitude, longitude];
          marker = { lat: latitude, lng: longitude };
        }
      } else {
        const polygon = L.polygon(geometry.coordinates);
        const getCenter = polygon.getBounds().getCenter();
        center = values(getCenter);
        marker = getCenter;
      }

      const mapValue = {
        marker,
        center,
        name,
        coordinates,
        latlngs,
        isCircle,
        orders: this.detailedInfo.orders,
        origin: this.detailedInfo.origin,
      };

      const originData = {
        name, code,
      };

      const infoList = [
        { key: 'origin', label: 'Origin', value: originData },
        { key: 'name', label: 'Namess', value: name },
        { key: 'maps', label: 'Map', value: mapValue },
      ];

      return infoList;
    },
    driver1Info() {
      const data = this.detailedInfo.confirmations.find(c => c.key === 'driver_1');
      return createConfirmationInfo(data);
    },
    driver2Info() {
      const data = this.detailedInfo.confirmations.find(c => c.key === 'driver_2');
      return createConfirmationInfo(data);
    },
    loader1Info() {
      const data = this.detailedInfo.confirmations.find(c => c.key === 'loader_1');
      return createConfirmationInfo(data);
    },
    loader2Info() {
      const data = this.detailedInfo.confirmations.find(c => c.key === 'loader_2');
      return createConfirmationInfo(data);
    },
  },
  watch: {
    detailedInfo(data) {
      this.selectedCompany = data.company;
      this.loader1Confirm = !!data.confirmations.find(c => c.key === 'loader_1');
      this.loader2Confirm = !!data.confirmations.find(c => c.key === 'loader_2');
      this.driver1Confirm = !!data.confirmations.find(c => c.key === 'driver_1');
      this.driver2Confirm = !!data.confirmations.find(c => c.key === 'driver_2');
    },
  },
  methods: {
    createSignature(data) {
      return `data:image/png;base64,${data}`;
    },
    getCenter(polygon) {
      return polygon.reduce((x, y) =>
        [x[0] + (y[0] / polygon.length), x[1] + (y[1] / polygon.length)], [0, 0]);
    },
    showHideMap() {
      this.showMap = !this.showMap;
      if (this.showMap && !this.setInvalidateSize) {
        setTimeout(() => { this.mapObject.invalidateSize(); }, 5e2);
        this.setInvalidateSize = !this.setInvalidateSize;
      }
    },
    showHideMapbox() {
      this.showMapbox = !this.showMapbox;
      if (this.showMapbox && !this.setInvalidateSize) {
        setTimeout(() => { this.mapObject.resize(); }, 5e2);
        this.setInvalidateSize = !this.setInvalidateSize;
      }
    },
  },
};
</script>
<style>
.confirm-signature {
  max-height: 130px;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/shipments/detail/Index.vue